function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var a = Object.defineProperty;
var m = Object.getOwnPropertySymbols;
var e = Object.prototype.hasOwnProperty,
    i = Object.prototype.propertyIsEnumerable;

var o = function o(h, c, t) {
  return c in h ? a(h, c, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : h[c] = t;
},
    n = function n(h, c) {
  for (var t in c || (c = {})) {
    e.call(c, t) && o(h, t, c[t]);
  }

  if (m) {
    var _iterator = _createForOfIteratorHelper(m(c)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        i.call(c, t) && o(h, t, c[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return h;
};

import * as z from "react";

function r(h) {
  return z.createElement("svg", n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, h), z.createElement("path", {
    d: "M21.266 4.59L16.896.655a2.647 2.647 0 00-1.766-.66H4.5C3.12 0 2 1.008 2 2.25v19.5C2 22.992 3.12 24 4.5 24h15c1.38 0 2.5-1.008 2.5-2.25V6.183c0-.595-.266-1.172-.734-1.594zm-1.177 1.063c.109.099.182.216.218.347h-4.974V1.524a.846.846 0 01.386.197l4.37 3.932zM19.5 22.5h-15c-.458 0-.833-.337-.833-.75V2.25c0-.412.375-.75.833-.75h9.167v4.875c0 .624.557 1.125 1.25 1.125h5.416v14.25c0 .413-.375.75-.833.75zm-1.146-8.025c-.703-.623-2.864-.431-3.838-.314-1.104-.6-1.834-1.425-2.35-2.653.225-.844.626-2.212.334-3.042-.23-1.317-2.068-1.158-2.323-.319-.26.858-.015 2.081.438 3.647-.62 1.331-1.547 3.136-2.193 4.153-1.083.502-2.818 1.373-3.063 2.456-.182.788 1.193 1.847 2.766.3.474-.464 1.005-1.162 1.63-2.133 1.39-.412 2.922-.928 4.271-1.125 1.14.563 2.48.933 3.365.933 1.442.005 1.505-1.415.963-1.903zM6.417 18.647c.307-.745 1.49-1.612 1.849-1.912-1.151 1.654-1.85 1.945-1.85 1.912zm4.958-10.42c.453 0 .406 1.758.11 2.231-.271-.764-.261-2.231-.11-2.231zm-1.48 7.467c.59-.928 1.095-2.025 1.5-2.986a6.329 6.329 0 001.829 1.945c-1.266.22-2.365.708-3.328 1.041zm7.99-.277s-.302.329-2.265-.426c2.135-.14 2.484.3 2.265.426z",
    fill: "black"
  }));
}

export { r as ReactComponent };